import { useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Loading from "components/Loading";
import { Container, Row, Col, Card } from 'react-bootstrap';
import ModalPingpong from "./modals/pingpong";
import useFormTopup from './hooks/useFormTopup';

const Topup = () => {
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const { t } = useTranslation();
    const { loading, handleAddTopUp } = useFormTopup();

    return (
        <>
            <Loading isLoading={loading} />
            <Container className="py-4">
                <h2 className="text-center mb-4">{t("Select Payment")}</h2>
                <Row xs={1} md={3} className="g-4">
                    <Col>
                        <Card className="text-center border-2 btn btn-outline btn-outline-dashed bg-opacity-25 shadow h-100" onClick={() => { setOpenModalAdd(true); }}>
                            <Card.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '40px' }}>
                                    <img src="https://dash.burgerprints.com/assets/img/PingPongLogo.svg" alt="PingPong" style={{ height: '24px', objectFit: 'contain' }} />
                                </div>
                                {/* <Card.Title as="h6" className="mb-1 text-dark">{t("PingPong")}</Card.Title> */}
                                <Card.Text className="text-muted" style={{ fontSize: '0.875rem' }}>0% {t("fee")}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* <Col>
                        <Card className="text-center border-2 btn btn-outline btn-outline-dashed bg-light opacity-50 cursor-not-allowed">
                            <Card.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '40px' }}>
                                    <img src="https://dash.burgerprints.com/assets/img/payoneer_logo.png" alt="Payoneer" style={{ height: '24px', objectFit: 'contain' }} />
                                </div>
                                <Card.Title as="h6" className="mb-1 text-dark">Payoneer</Card.Title>
                                <Card.Text className="text-muted" style={{ fontSize: '0.875rem' }}>0 - 1% fee</Card.Text>
                                <p className="text-danger" style={{ fontSize: '0.75rem' }}>Coming soon</p>
                            </Card.Body>
                        </Card>
                    </Col> */}
                    {/* <Col>
                        <Card className="text-center border-2 btn btn-outline btn-outline-dashed bg-light opacity-50 cursor-not-allowed">
                            <Card.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '40px' }}>
                                    <img src="https://d1ud88wu9m1k4s.cloudfront.net/pod/pro/assets/img/payin/lianlian.png" alt="LianLian" style={{ height: '24px', objectFit: 'contain' }} />
                                </div>
                                <Card.Title as="h6" className="mb-1 text-dark">LianLian</Card.Title>
                                <Card.Text className="text-muted" style={{ fontSize: '0.875rem' }}>0% fee</Card.Text>
                                <p className="text-danger" style={{ fontSize: '0.75rem' }}>Coming soon</p>
                            </Card.Body>
                        </Card>
                    </Col> */}
                    <Col>
                        <Card className="text-center border-2 btn btn-outline btn-outline-dashed bg-light opacity-50 cursor-not-allowed">
                            <Card.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '40px' }}>
                                    <img src="https://dash.burgerprints.com/assets/img/world_first_icon.png" alt="WorldFirst" style={{ height: '24px', objectFit: 'contain' }} />
                                </div>
                                {/* <Card.Title as="h6" className="mb-1 text-dark">{t("WorldFirst")}</Card.Title> */}
                                <Card.Text className="text-muted" style={{ fontSize: '0.875rem' }}>0% {t("fee")}</Card.Text>
                                <p className="text-danger" style={{ fontSize: '0.75rem' }}>{t("Coming soon")}</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* <Col>
                        <Card className="text-center border-2 btn btn-outline btn-outline-dashed bg-light opacity-50 cursor-not-allowed">
                            <Card.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '40px' }}>
                                    <span className="fw-bold fs-5 text-dark">Credit Card</span>
                                </div>
                                <Card.Title as="h6" className="mb-1 text-dark">Credit Card</Card.Title>
                                <Card.Text className="text-muted" style={{ fontSize: '0.875rem' }}>From 2.9% + 0.3$</Card.Text>
                                <p className="text-danger" style={{ fontSize: '0.75rem' }}>Coming soon</p>
                            </Card.Body>
                        </Card>
                    </Col> */}
                    <Col>
                        <Card className="text-center border-2 btn btn-outline btn-outline-dashed bg-light opacity-50 cursor-not-allowed">
                            <Card.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '40px' }}>
                                    <img src="https://images.squarespace-cdn.com/content/v1/6256bbc958459115bb736708/ff8b5bda-1238-4478-baa4-0012ea756ec4/airwallex_logo2.png" alt="Airwallex" style={{ height: '24px', objectFit: 'contain' }} />
                                </div>
                                <Card.Text className="text-muted" style={{ fontSize: '0.875rem' }}>0% {t("fee")}</Card.Text>
                                <p className="text-danger" style={{ fontSize: '0.75rem' }}>{t("Coming soon")}</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* <Col>
                        <Card className="text-center border-2 btn btn-outline btn-outline-dashed bg-light opacity-50 cursor-not-allowed">
                            <Card.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '40px' }}>
                                    <span className="fw-bold fs-5 text-dark">Online Banking</span>
                                </div>
                                <Card.Title as="h6" className="mb-1 text-dark">Online Banking</Card.Title>
                                <Card.Text className="text-muted" style={{ fontSize: '0.875rem' }}>0% fee/USD</Card.Text>
                                <p className="text-danger" style={{ fontSize: '0.75rem' }}>Coming soon</p>
                            </Card.Body>
                        </Card>
                    </Col> */}
                </Row>
            </Container>
            <ModalPingpong
                title={t("Payment Details")}
                isOpen={openModalAdd}
                onClose={() => setOpenModalAdd(false)}
                onSubmit={(formData) => {
                    handleAddTopUp(formData);
                }}
            />
        </>
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Topup);
